'use strict'

// ---
// ---
// ---

try {
	module.exports = document || {}
} catch (e) {
	module.exports = {}
}

// ---
